<template>
  <fieldset class="border rounded m-2 px-2 pt-2">
    <vxe-form class="mb-2" ref="anyForm" :data="table.formData" :rules="table.rules" titleAlign="right" @submit="table.save">
        <vxe-form-item title="姓名" field="Name" :item-render="{}" span="4">
          <template #default="{ data }">
            <vxe-input type="text" v-model="data.Name" placeholder="輸入姓名" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="性別" field="Sex" :item-render="{}" span="4">
          <template #default="{ data }">
            <vxe-select v-model="data.Sex" placeholder="請選擇性別" clearable>
              <vxe-option v-for="(item) in Object.values(model.enums.Sex).map(e => { return { label: e.Name, value: e.Value } })" :key="'flow-type' + item.value" :value="item.value" :label="item.label"></vxe-option>
            </vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="學歷" field="Education" :item-render="{}" span="5">
          <template #default="{ data }">
            <vxe-input type="text" v-model="data.Education" placeholder="請輸入文字" clearable></vxe-input>
          </template>
        </vxe-form-item>
         <vxe-form-item title="經歷" field="Experience" :item-render="{}" span="5">
          <template #default="{ data }">
            <vxe-input type="text" v-model="data.Experience" placeholder="請輸入文字" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="出生年月日" field="BirthDate" :item-render="{}" span="6">
          <template #default="{ data }">
            <vxe-input type="date" v-model="data.BirthDate" placeholder="請輸入日期" label-format="yyyy/MM/dd" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="職稱" field="JobTitle" :item-render="{}" span="5">
          <template #default="{ data }">
            <vxe-input type="text" v-model="data.JobTitle" placeholder="請輸入文字" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="Email" field="Email" :item-render="{}" span="7">
          <template #default="{ data }">
            <vxe-input type="text" v-model="data.Email" placeholder="請輸入文字" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="備註" field="Remark" :item-render="{}" span="8">
          <template #default="{ data }">
            <vxe-input type="text" v-model="data.Remark" placeholder="請輸入文字" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item :item-render="{}" span="4">
          <template #default>
            <vxe-button type="submit" status="primary" :content="table.isEditing ? '修改' : '確認'">
            </vxe-button>
            <vxe-button v-if="table.isEditing" type="button" @click="table.reset" status="danger" content="取消">
            </vxe-button>
          </template>
        </vxe-form-item>
    </vxe-form>
    <vxe-table class="mb-2" ref="grid" :data="table.data" v-bind="gridOptions.props">
      <vxe-column field="Ordinal" title="排序" :visible="false" sortable>
      </vxe-column>
      <vxe-column field="Name" title="姓名" sortable>
      </vxe-column>
      <vxe-column field="Sex" title="性別" :formatter=" ({ cellValue }) => model ? Object.values(model.enums.Sex).find(e => e.Value === cellValue)?.Name : ''" sortable>
      </vxe-column>
      <vxe-column field="Education" title="學歷" sortable>
      </vxe-column>
      <vxe-column field="Experience" title="經歷" sortable>
      </vxe-column>
      <vxe-column field="BirthDate" title="出生年月日" :formatter="({ cellValue }) => formatDate(cellValue, 'yyyy/MM/dd')">
      </vxe-column>
      <vxe-column field="JobTitle" title="職稱" sortable>
      </vxe-column>
      <vxe-column field="Email" title="Email" sortable>
      </vxe-column>
      <vxe-column field="Remark" title="備註" sortable>
      </vxe-column>
      <vxe-column v-if="!readType" title="操作" width="200">
        <template #default="{ row }">
          <div class="flex justify-content">
            <vxe-button @click="table.update(row)">編輯</vxe-button>
            <vxe-button @click="table.delete(row)">刪除</vxe-button>
          </div>
        </template>
      </vxe-column>
    </vxe-table>
  </fieldset>
</template>
<script lang="ts">
/* eslint-disable */
import CloudFun, { defineComponent, ref, reactive, PropType, Condition, Operator } from "@cloudfun/core";
import { watch } from "vue";
import { VxeTableProps, VxeFormProps } from "vxe-table";
import { commafy } from "xe-utils";
import formatDate from 'xe-utils/toDateString';

export default defineComponent({
  name: "FlowTable",
  components: {
  },
  props: {
    data: {
      type: Array as PropType<any[]>,
      default: () => []
    },
    aid: Number,
    customerId: Number,
    visible: Boolean,
    readType: Boolean,
  },
  setup(props, { emit }) {
    const model = CloudFun.current?.model;
    const grid = ref<any>();
    const gridOptions = {
      props: {
        sortConfig: {
          multiple: true,
          defaultSort: [{ field: 'Ordinal', order: 'asc' }]
        }
      } as VxeTableProps,
      insert() {
        const { row } = grid.value.insertAt({}, 0);
        grid.value.setActiveRow(row)
      }
    }

    const table = reactive({
      data: [] as any[],
      isLoading: false,
      isEditing: false,
      formData: {  } as any,
      selectedRow: null as any | null,
      // insert() {
      //   table.formData = { OutSource: false, Fee: 0, PayStatus: 0, Ordinal: 0 };
      //   table.selectedRow = null;
      //   table.isEditing = true;
      // },
      update(row: any) {
        // console.log(row)
        table.formData = { ...row };
        table.selectedRow = row;
        table.isEditing = true;
      },
      delete(row: any) {
        grid.value.remove(row);
        table.reset();

      },
      submit() {
        emit('submit', grid.value.getTableData().fullData)
      },
      reset() {
        table.formData = {};
        table.formData.Name = null;
        table.formData.JobTitle = null;
        table.formData.Education = null;
        table.formData.Experience = null;
        table.formData.Remark = null;
        table.formData.Sex = 0;
        table.formData.Ordinal = 0;
        table.formData.BirthDate = null;
        table.formData.Email = null;
        table.selectedRow = null;
        table.isEditing = false;
      },
      async save() {
        
        if(table.isEditing) {
          // 編輯確認
          Object.assign(table.selectedRow, table.formData);
        } else {
          // 新增確認
          table.formData.Ordinal = getNextOrdinal();
          await grid.value.insert(table.formData);
        }
        table.reset();
        await grid.value.sort("Ordinal", 'asc');
      },
      rules: {
        Name: [{ required: true }],
        Sex: [{ required: true }],
        Email: [{ message: "Email格式錯誤", pattern: new RegExp("^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z]+$") }],
      }
    })

    const getNextOrdinal = () => {
      const data = grid.value.getTableData().fullData;
      if(!data || data.length == 0) return 1; 
      var maxOrdinal = Math.max(...data.map((e: any) => e.Ordinal));
      return (maxOrdinal ?? 0) + 1;
    }

    watch(() => props.aid, async(value) => {
      if(value) {
        if(props.data && props.data.length > 0) {         
          table.data = props.data;
        } else {
          table.data = [] as any;
        }
        table.reset();        
      } else {
        table.data = [] as any;
        table.reset();
      }
    }, { immediate: true });

    const anyForm = ref<any>();


    const TF = [{ label: "是", value: true }, { label: "否", value: false }];

    return {
      table,
      grid,
      gridOptions,
      anyForm,
      model,
      TF,
      commafy,
      formatDate,
    }
  },
  methods: {
    getData() {
      return this.grid.getTableData().fullData;
    }
  }
})
</script>
